/**
 * Lista de acciones para registros
 */

export enum AccionEnum {
    VER = 1,
    EDITAR = 2,
    CREAR = 3,
    ELIMINAR = 4,
}